import "./index.css";
import About from "./components/About";

function App() {
  return (
    <div className="App">
      <About />
    </div>
  );
}

export default App;
